/**
 * @author gyb(mocheer)
 * @email mocheer@foxmail.com  
 * @since 2017.7.7
 */
import PointTool from './PointTool'

//
/**
 * 点图元绘制工具
 */
export default class TextTool extends PointTool {
  options = { feature: {} }
  /**
   * 绘制-start
   * @param e 
   */
  onMouseDown(e) {
    let { latlng } = e;
    let { options, layer } = this;
    //
    this.marker = L.text(latlng, options.text, options.feature).addTo(layer)
    this.onEnd();
  }
}


// WEBPACK FOOTER //
// ./src/plugins/tools/TextTool.js